<script lang="ts">
  /**
   * Reusable Credits component for project pages
   * Props:
   * - client: string (label for 'Commissioned by' or 'Client')
   * - team: array of { name: string, role?: string, url?: string }
   * - website: string (optional, project or client website)
   */
  export let client: { label: string; name: string; url?: string };
  export let team: Array<{ name: string; role?: string; url?: string }> = [];
  export let website: string = "";
  import ScrambleIn from './ScrambleIn.svelte';
</script>

<div class="credits-section animate-on-view border-t pt-4 md:pt-8 mb-8 md:mb-8">
  <ScrambleIn text="Credits" className="text-2xl font-light mb-8 md:mb-16" />
  <ul class="space-y-2 mt-4 md:mt-8">
    {#if client}
      <li>
        <strong>{client.label}</strong>
        {#if client.url}
          <a href={client.url} class="text-accent-color hover:underline" target="_blank" rel="noopener noreferrer">{client.name}</a>
        {:else}
          {client.name}
        {/if}
      </li>
    {/if}
    {#if team.length}
      <li>
        <ul class="mt-1 space-y-1">
          {#each team as member}
            <li>
                {#if member.role}
                <span class="text-gray-500">{` — ${member.role}`}</span>
              {/if}
              {#if member.url}
                <a href={member.url} class="hover:underline" target="_blank" rel="noopener noreferrer">{member.name}</a>
              {:else}
                {member.name}
              {/if}
            </li>
          {/each}
        </ul>
      </li>
    {/if}
    {#if website}
      <li>
        <strong>Website</strong> <a href={website} class="text-accent-color hover:underline" target="_blank" rel="noopener noreferrer">{website.replace(/^https?:\/\//, "")}</a>
      </li>
    {/if}
  </ul>
</div>

<style>
.credits-section {
  border-color: var(--accent, #F96604);
  opacity: 0.95;
}
.text-accent-color {
  color: var(--accent, #F96604);
}
</style> 